import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import {
  formatUSDNoDecimals,
  walletsNFTWithdraw
} from '../../helpers/helperFunctions';
import { CaptionText, H3, H4, P1, P3 } from '../../styles/FontStyles';

import Countdown from 'react-countdown';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD } from '../../helpers/helperFunctions';
import { BIG_WHALE, MARKETPLACE } from '../../routes/routes';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed,
  SectionSeparatorVertical
} from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCalculator,
  IconPortfolioDiamond,
  IconPortfolioDistribution,
  IconPortfolioMoney,
  IconPortfolioOrders,
  IconPortfolioStaked,
  IconPortfolioStaking
} from '../../styles/Icons';
import { AutoStake } from './Autostake/AutoStake';
import { RioCalculator } from './CalculateTable';
import { Claim } from './Claim/Claim';
import { ClaimCalculator } from './Claim/ClaimCalculator';
import { Overlay } from './Overlay';
import { getMyHubsStaking } from './Portfolio.actions';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';
import { UserPackage } from './Portfolio.types';
import { PortfolioItem } from './PortfolioItem';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';

interface StakingHubProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
}

export const StakingHubSummary = ({
  withdrawStep,
  setWithdrawStep
}: StakingHubProps) => {
  const dispatch = useDispatch();

  const { t } = useTranslation('my_hubs');
  const history = useHistory();
  const ref = useRef<any>(null);

  const [claim, setClaim] = useState(false);
  const [autostake, setAutostake] = useState(false);
  const [calculator, setCalculator] = useState(false);
  const [claimCalculator, setClaimCalculator] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [packageItem, setPackageItem] = useState<UserPackage | null>(null);
  const [expanded, setExpanded] = useState(true);
  const [claimStep, setClaimStep] = useState(1);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [selectedNFTWallet, setSelectedNFTWallet] = useState<any>(
    walletsNFTWithdraw[0]
  );

  let now = new Date();
  now.setDate(now.getDate() + 1);
  now.setHours(13);
  now.setSeconds(0);
  now.setMinutes(0);
  now.setMilliseconds(0);

  const { staking } = useAppSelector((state) => state.portfolio);

  const {
    isCanadaRestrictedUser,
    isJapanRestrictedUser,
    canBuyStakingPackages
  } = useAppSelector((state) => state.auth.userInfo);

  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds }: any) => {
    return (
      <div>
        {hours}h: {minutes}m: {seconds}s
      </div>
    );
  };

  useEffect(() => {
    dispatch(getMyHubsStaking());
  }, [dispatch]);

  const [height, setHeight] = useState(ref?.current?.clientHeight);
  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, [staking]);

  return (
    <>
      <Flexed mb='20' center between rowSM>
        <H3 mbSM='10'>{t('my_ultron_staking_hub_nfts_summary')}</H3>
        {!isCanadaRestrictedUser && (
          <Button
            negative
            maxWidth='350px'
            maxWidthSM='100%'
            onClick={() =>
              history.push(canBuyStakingPackages ? MARKETPLACE : BIG_WHALE)
            }>
            {t('add_staking_hub_nft')}
          </Button>
        )}
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioStaking />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('base_stake')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(staking?.summary?.baseStake || 0)} <P3 mb='1'>wULX</P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioStaked />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_stalked')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(staking?.summary?.totalStake || 0)}
              <P3 mb='1'>wULX</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio
          onClick={() => setCalculator(true)}
          style={{ cursor: 'pointer' }}>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioMoney />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              apR
            </CaptionText>
            <P1 bold flex gap='5px'>
              73%
              <Icon ml='5'>
                <IconCalculator />
              </Icon>
            </P1>
          </div>
          <SectionSeparatorVertical margin='0 40px' h='30px' />
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              apy
            </CaptionText>
            <P1 bold flex gap='5px'>
              107%
              <Icon ml='5'>
                <IconCalculator />
              </Icon>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_ultron_staking_hub_nft_order')}
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSDNoDecimals(staking?.summary?.totalOrderAmount || 0)}{' '}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioDiamond />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_orders_with_autostake_on')}
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSDNoDecimals(
                staking?.summary?.totalOrderWithAutostakeIntactAmount || 0
              )}{' '}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioDistribution />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('next_processing_starts_in')}
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              <Countdown date={now} renderer={renderer} />
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <Flexed
        mb='20'
        center
        gap='20px'
        pointer
        onClick={() => setExpanded(!expanded)}>
        <H4>{t('my_ultron_staking_hub_nfts')} </H4>
        <ArrowChevron direction={expanded ? 'up' : 'down'} />
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {staking?.userPackages?.map((item, index) => (
            <PortfolioItem
              setClaim={setClaim}
              setClaimStep={setClaimStep}
              key={index}
              item={item}
              setAutostake={setAutostake}
              setPackageItem={setPackageItem}
              claimCalculator={claimCalculator}
              setClaimCalculator={setClaimCalculator}
              setToggle={setToggle}
              toggle={toggle}
              withdrawModal={withdrawModal}
              setWithdrawModal={setWithdrawModal}
              setSelectedNFTWallet={setSelectedNFTWallet}
            />
          ))}
        </div>
      </Collapsable>

      <SidebarModal
        isOpen={calculator}
        setOpen={setCalculator}
        title={t('rio_calculator.title')}
        sidebarWidth={'508px'}>
        <RioCalculator setCalculator={setCalculator} />
      </SidebarModal>
      <SidebarModal
        isOpen={claimCalculator}
        setOpen={setClaimCalculator}
        title={t('claim.claim_calculator')}
        sidebarWidth={'580px'}>
        <ClaimCalculator
          setClaimCalculator={setClaimCalculator}
          packageItem={packageItem}
        />
      </SidebarModal>
      <SidebarModal
        isOpen={claim}
        setOpen={setClaim}
        title={t('claim.claim_title')}
        sidebarWidth={'560px'}>
        <Claim
          setClaim={setClaim}
          setClaimStep={setClaimStep}
          claimStep={claimStep}
          packageItem={packageItem}
        />
      </SidebarModal>
      <SidebarModal
        isOpen={autostake}
        setOpen={setAutostake}
        title={'auto-stake settings'}
        sidebarWidth={'508px'}>
        <AutoStake
          setAutostake={setAutostake}
          packageItem={packageItem}
          setToggle={setToggle}
          toggle={toggle}
          isOpen={autostake}
        />
      </SidebarModal>

      <WithdrawHubs
        openModal={withdrawModal}
        setOpenModal={setWithdrawModal}
        packageId={packageItem?.id ?? 0}
        withdrawStep={withdrawStep}
        setWithdrawStep={setWithdrawStep}
        item={packageItem as UserPackage}
        selectedNFTWallet={selectedNFTWallet}
        setSelectedNFTWallet={setSelectedNFTWallet}
      />

      <Overlay />
    </>
  );
};
